/** Consejos de seguridad con armas — tono positivo y profesional */
export const SAFETY_PHRASES: string[] = [
  "Trata cada arma como si estuviera cargada: la prudencia es tu mejor aliada.",
  "Dedo fuera del guardapolvo hasta decidir disparar — disciplina que protege a todos.",
  "Bóveda o caja fuerte, munición aparte: en casa, la seguridad va primero.",
  "Conocer tu equipo a fondo es el primer paso hacia un manejo impecable.",
  "La seguridad no es restrictiva: es el hábito que te permite entrenar con confianza.",
  "Un segundo de atención vale más que mil excusas: revisa siempre el estado del arma.",
  "Comparte el deporte y la caza con responsabilidad; el respeto al arma fortalece a la comunidad.",
  "Mantén el cañón en zona segura: lo que ves es hacia donde apunta tu compromiso.",
];
